import { LazyMotion, domAnimation } from 'motion/react';
import { ThemeProvider } from './theme';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { FloorPlans } from './components/FloorPlans';
import { Gallery } from './components/Gallery';
import { Amenities } from './components/Amenities';
import { Location } from './components/Location';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { WhatsAppFAB } from './components/WhatsAppFAB';
import { LeadWidget } from './components/LeadWidget';

export default function App() {
  return (
    <ThemeProvider>
      {/* domAnimation: initial/animate/exit/whileInView/variants yeter.
          Sürükleme ve layout-projection motorunu bundle dışında bırakır.
          strict: yanlışlıkla motion.X kullanılırsa build yerine anında hata verir. */}
      <LazyMotion features={domAnimation} strict>
        {/* Alt boşluk: mobildeki yapışkan şerit sayfanın son satırını kapatmasın */}
        <div className="min-h-screen pb-[68px] min-[1440px]:pb-0 bg-white dark:bg-slate-950 transition-colors duration-300 overflow-x-hidden">
          <Navbar />
          <Hero />
          <About />
          <FloorPlans />
          <Gallery />
          <Amenities />
          <Location />
          <Testimonials />
          <FAQ />
          <Contact />
          <Footer />
          <LeadWidget />
          <WhatsAppFAB />
        </div>
      </LazyMotion>
    </ThemeProvider>
  );
}
